import ipaddr from 'ipaddr.js'

interface IP2LocationData {
  request_id: string
  status: string
  code: string
  message: string
  data: Array<{
    ip_info: {
      ip: string
      version: number
      use_vpn: false
    }
    geo_info: {
      latitude: number
      longitude: number
      country: {
        name: string
        iso2_code: string
        prohibited: boolean
        ip_limit: boolean
        eu: boolean
      }
      state: {
        name: string
        prohibited: boolean
      }
    }
  }>
  metadata: {}
}

// 严格的 IP 格式验证
function isValidIP(ip: string): boolean {
  if (!ip || ip === '0.0.0.0') return false;

  try {
    // 使用 ipaddr.js 进行严格验证
    const addr = ipaddr.parse(ip);
    return true;
  } catch {
    // 不是有效的 IPv4 或 IPv6
    return false;
  }
}


export default defineNuxtRouteMiddleware(async (event) => {
  if (import.meta.server) {
    const { ip2LocationToken, public: { apiHost, siteRegion } } = useRuntimeConfig()
    if (ip2LocationToken) {
      // 获取所有可能的 IP 头
      const forwardedFor = useRequestHeader('x-forwarded-for');
      const realIp = useRequestHeader('x-real-ip');
      const cfConnectingIp = useRequestHeader('cf-connecting-ip'); // Cloudflare
      const remoteAddress = useRequestHeader('remote_addr');

      // 优化 IP 获取逻辑
      const getClientIP = () => {
        // 按优先级尝试获取 IP
        if (cfConnectingIp) return cfConnectingIp.split(',')[0].trim();
        if (realIp) return realIp.split(',')[0].trim();
        if (forwardedFor) {
          // x-forwarded-for 可能有多个 IP（代理链）
          const ips = forwardedFor.split(',').map(ip => ip.trim());
          // 第一个 IP 是最原始的客户端 IP（如果信任所有代理）
          // 最后一个 IP 是最近的代理 IP（如果不完全信任代理链）
          return ips[0]; // 或者 ips[ips.length - 1]
        }
        return remoteAddress;
      };

      const clientIp = getClientIP();
      if (clientIp && isValidIP(clientIp)) {
        const { data, status, code, message, metadata } = await $fetch<IP2LocationData>(
          `https://${apiHost}/v2/app/ip?ip=${clientIp}&source=lgweb`,
          {
            headers: {
              Authorization: `Bearer ${ip2LocationToken}`,
            },
          },
        )
        if (status === 'success') {
          if (data.length) {
            const { geo_info } = data[0]
            // GB 是大不列颠, 所以不限制
            if (geo_info?.country?.ip_limit && !['GB'].includes(geo_info?.country.iso2_code)) {
              throw createError({
                statusCode: 405,
                statusText: code,
                message: `You are accessing Legend Trading services from ${geo_info?.country.name}. <br>
                Due to compliance reasons, we are unable to offer services to users from this region.`,
              } as any)
            } else if (geo_info?.country?.eu && siteRegion === 'www') {
              // 如果是eu区并且站点是www，则跳转到eu.legendtrading.com
              return navigateTo('https://eu.legendtrading.com', {
                external: true,
                replace: false,
                redirectCode: 302
              })
            }
          }
        }
      }

    }
  }
})
